<template>
  <div>
    <div class="row">
        <div class="col-sm-12">
          <div class="page-title-box">
            <div class="float-right">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:void(0);">BPD BALI</a></li>
                <li class="breadcrumb-item active">Transaksi Tetap</li>
              </ol>
            </div>
            <h4 class="page-title">Transaksi Tetap</h4>
          </div>
        </div>
      </div>
    <div class="card card-loader d-flex" v-if="loading">
          <div class="justify-content-center">
            <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <p class="mt-2">Loading</p>
          </div>
      </div>

      <div class="card" v-else>
          <div class="card-body">
            <div class="wrapper-table-default">
                <router-link :to="{ name: 'instanceTransactionFixedCreate' }" 
                v-if="$store.state.permission.includes('billing.store')"
                class="btn btn-success waves-effect waves-light left-action">Tambah Transaksi</router-link>
                <button type="button" class="btn btn-warning float-right" @click.prevent="sync"
                    :disabled="loadingSync"
                    v-if="$store.state.permission.includes('billing.store')">
                    <div class="spinner-border" role="status" v-if="loadingSync">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <i class="fas fa-sync-alt" v-else></i> Sinkronisasi Tagihan
                </button>
                <div class="table-responsive">
                    <table id="table-default" class="table table-hover with-action-last" cellspacing="0" width="100%">
                        <thead>
                            <tr>
                                <th>Nama Tagihan</th>
                                <th>Periode / Tanggal Tagihan</th>
                                <th v-if="$store.state.permission.includes('billing.store')">Aksi</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item) in dataTransaction" :key="item.id">
                                <td>{{ item.name }}</td>
                                <td>Periode {{ item.period_value }} bulan,  ditagih setiap tanggal {{ item.billing_date }}</td>
                                <td v-if="$store.state.permission.includes('billing.store')">
                                    <button class="btn btn-warning waves-effect waves-light" @click.prevent="syncPerTransaction(item.id)"
                                        :disabled="loadingSyncPerTransaction"
                                        v-if="$store.state.permission.includes('billing.store')">
                                        <div class="spinner-border" role="status" v-if="loadingSyncPerTransaction">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                        <i class="fas fa-sync-alt" v-else></i>
                                    </button>
                                    <router-link class="btn btn-primary waves-effect waves-light ml-2"
                                        :to="{ name: 'instanceTransactionFixedEdit', params: { id: item.id } }"
                                        v-if="$store.state.permission.includes('billing.store')">
                                        <i class="fas fa-pen"></i>
                                    </router-link>
                                    <button class="btn btn-danger waves-effect waves-light ml-2" @click.prevent="deleteItem(item.id, item.name)"
                                        v-if="$store.state.permission.includes('billing.store')">
                                        <i class="fas fa-trash"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
          </div>
      </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import moment from "moment"
export default {
    data() {
        return {
            loading: true,
            loadingDetail: false,
            loadingSync: false,
            loadingSyncPerTransaction: false,

            dataDetail : '',
            dataTransaction: [],
        }
    },
    methods: {
        // LOAD DATA
        loadData() {
            this.loading = true;
            this.$http.get(`${this.API_URL}billing`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
            })
            .then(response => {
                this.loading = false;
                const result = response.data;
                if(result.success) {
                    this.dataTransaction = result.data
                    setTimeout(() => {
                        this.dataTableSearch()
                    }, 500);
                }else {
                    this.sAlert('error', result.message)
                }
            })
            .catch(error => {
                this.loading = false;
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            });
        },
        sync() {
            this.loadingSync = true
            this.$http.get(`${this.API_URL}billing/sync`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
            })
            .then(response => {
                this.sAlert('success', 'Berhasil sinkronisasi data tagihan tetap!')
                this.loadingSync = false
            })
            .catch(error => {
                this.loadingSync = false
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            });
        },
        syncPerTransaction(id) {
            this.loadingSyncPerTransaction = true
            this.$http.get(`${this.API_URL}billing/sync/${id}`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
            })
            .then(response => {
                this.sAlert('success', 'Berhasil sinkronisasi data tagihan tetap!')
                this.loadingSyncPerTransaction = false
            })
            .catch(error => {
                this.loadingSyncPerTransaction = false
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            });
        },
        // DELETE ITEM
        async deleteItem(id, trxCode){
            const { value: text } = await Swal.fire({
                title: 'Apakah anda yakin untuk menghapus?',
                input: 'text',
                inputPlaceholder: 'Masukkan Kode Transaksi',
                showCancelButton: true,
                confirmButtonText: 'Ya, Hapus!',
                html: `
                Masukkan <b>${trxCode}</b> pada kolom dibawah untuk konfirmasi hapus data!
                `,
                inputValidator: (value) => {
                    if (value != trxCode) {
                        return 'Kode yang anda masukkan salah, coba lagi!'
                    }
                }
            })

            if (text == trxCode) {
                this.loading = true
                    this.$http.delete(`${this.API_URL}billing/delete/${id}`, {
                    headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
                })
                .then(() => {
                    this.loadData()
                })
                .catch(error => {
                    this.sAlert('error', "Error, Terjadi Kesalahan!")
                });
            }
        },
        // CONVERT DATE
        convertDate(date){
            return moment(date).format('DD MMMM YYYY')
        }
    },
    mounted() {
        if(!this.$store.state.userData.company.is_billing == 1){
            this.$router.push({ name: 'instanceDashboard' });
        }
        this.loadData()
    }
}
</script>